import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {createStaticValidator} from './common';

const NumericPattern = /[0-9]/;
export const Numeric = createStaticValidator((control: AbstractControl) => NumericPattern.test(control.value), {
  numeric: true,
});

@Directive({
  selector: '[numeric]',
  providers: [{provide: NG_VALIDATORS, useExisting: NumericDirective, multi: true}],
})
export class NumericDirective implements Validator {
  validate = Numeric;
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/numeric.validator.ts